import { IoClose } from "react-icons/io5";
import { AVAILABILITY_OPTIONS, FORMAT_OPTIONS, PRICING_OPTIONS } from "./booksQueryParams";

const labelFor = (options, value) =>
	options.find((option) => option.value === value)?.label || value;

const splitMulti = (value) => (value ? value.split("*").filter(Boolean) : []);

const buildChips = (filters, publishers) => {
	const chips = [];

	if (filters.searchTerm) {
		chips.push({
			key: "search",
			label: `"${filters.searchTerm}"`,
			prefix: "Search",
			onRemove: () => filters.changeSearchTerm(""),
		});
	}

	splitMulti(filters.tagIs).forEach((tag) => {
		chips.push({
			key: `tag-${tag}`,
			label: tag,
			prefix: "Tag",
			accent: true,
			onRemove: () =>
				filters.changeTagIs(
					splitMulti(filters.tagIs)
						.filter((item) => item !== tag)
						.join("*"),
				),
		});
	});

	splitMulti(filters.genreIs).forEach((genre) => {
		chips.push({
			key: `genre-${genre}`,
			label: genre,
			prefix: "Collection",
			onRemove: () =>
				filters.changeGenreIs(
					splitMulti(filters.genreIs)
						.filter((item) => item !== genre)
						.join("*"),
				),
		});
	});

	if (filters.categoryIs) {
		chips.push({
			key: "category",
			label: filters.categoryIs,
			prefix: "Category",
			onRemove: () => filters.changeCategoryIs(""),
		});
	}

	if (filters.publisherIs) {
		const publisher = publishers?.find(
			(item) => item.id?.toString() === filters.publisherIs?.toString(),
		);
		chips.push({
			key: "publisher",
			label: publisher?.name || `#${filters.publisherIs}`,
			prefix: "Publisher",
			onRemove: () => filters.changePublisherIs(""),
		});
	}

	if (filters.pricingModelIs) {
		chips.push({
			key: "pricing",
			label: labelFor(PRICING_OPTIONS, filters.pricingModelIs),
			prefix: "Pricing",
			onRemove: () => filters.changePricingModelIs(""),
		});
	}

	if (filters.format) {
		chips.push({
			key: "format",
			label: labelFor(FORMAT_OPTIONS, filters.format),
			prefix: "Format",
			onRemove: () => filters.changeFormat(""),
		});
	}

	if (filters.countryIs) {
		chips.push({
			key: "country",
			label: filters.countryIs,
			prefix: "Country",
			onRemove: () => filters.changeCountryIs(""),
		});
	}

	if (filters.language) {
		chips.push({
			key: "language",
			label: filters.language,
			prefix: "Language",
			onRemove: () => filters.changeLanguage(""),
		});
	}

	if (filters.availability) {
		chips.push({
			key: "availability",
			label: labelFor(AVAILABILITY_OPTIONS, filters.availability),
			prefix: "Availability",
			onRemove: () => filters.changeAvailability(""),
		});
	}

	if (filters.priceMin || filters.priceMax) {
		chips.push({
			key: "price",
			label: `${filters.priceMin || "0"} – ${filters.priceMax || "any"}`,
			prefix: "Price",
			onRemove: () => {
				filters.changeFilters({ price_min: "", price_max: "" });
			},
		});
	}

	if (filters.publicationDateFrom || filters.publicationDateTo) {
		chips.push({
			key: "published",
			label: `${filters.publicationDateFrom || "…"} → ${filters.publicationDateTo || "…"}`,
			prefix: "Published",
			onRemove: () => {
				filters.changeFilters({ publication_date_from: "", publication_date_to: "" });
			},
		});
	}

	if (filters.pageCountMin || filters.pageCountMax) {
		chips.push({
			key: "pages",
			label: `${filters.pageCountMin || "0"} – ${filters.pageCountMax || "any"} pages`,
			prefix: "Length",
			onRemove: () => {
				filters.changeFilters({ page_count_min: "", page_count_max: "" });
			},
		});
	}

	return chips;
};

const ActiveFilters = ({ filters, publishers, onClearAll }) => {
	const chips = buildChips(filters, publishers);

	if (chips.length === 0) return null;

	return (
		<div className="catalogue-active-filters" role="group" aria-label="Active filters">
			<span>Filtering by</span>
			{chips.map((chip) => <button key={chip.key} type="button" onClick={chip.onRemove} aria-label={`Remove ${chip.prefix} filter ${chip.label}`} title={chip.label}><span><span className="catalogue-chip-prefix">{chip.prefix}: </span>{chip.label}</span><IoClose aria-hidden="true" /></button>)}
			<button type="button" className="catalogue-clear-filters" onClick={onClearAll}>Clear all</button>
		</div>
	);
};

export default ActiveFilters;
